<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm03_tit"><a id="page_iii"></a><strong>Keeping Your Child Healthy in a Germ-Filled World</strong></h1>
<p class="subtitle"><strong>A G<span class="smallcaps">UIDE</span> <em>for</em> P<span class="smallcaps">ARENTS</span></strong></p>
<p class="author">Athena P. Kourtis, M.D., Ph.D., M.P.H.</p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_tit.vue?1a535233